import React from "react";
import { useLocation } from "react-router-dom";
import { LuFacebook, LuInstagram, LuMail, LuMapPin, LuPhone } from "react-icons/lu";

import logo from "../../assets/images/bleustay-03_small.png";
import { useI18n } from "../../i18n";

export default function Footer({ name, contact, fbLink, instaLink }) {
  const { t } = useI18n();
  // The home page has its own location section; repeating it here would be noise.
  const onHome = useLocation().pathname === "/";
  const place = contact ? [contact.address, contact.city, contact.country].filter(Boolean).join(", ") : "";

  return (
    <footer className="f-footer">
      {!onHome && name && (place || contact?.phone || contact?.email || fbLink || instaLink) && (
        <div className="f-footer-hotel">
          <div className="f-footer-hotel-name">{name}</div>
          <ul>
            {place && <li><LuMapPin size={16} /> {place}</li>}
            {contact?.phone && <li><LuPhone size={16} /> <a href={`tel:${contact.phone.replace(/\s+/g, "")}`}>{contact.phone}</a></li>}
            {contact?.email && <li><LuMail size={16} /> <a href={`mailto:${contact.email}`}>{contact.email}</a></li>}
          </ul>
          {(fbLink || instaLink) && (
            <div className="f-footer-social">
              {fbLink && <a href={fbLink} target="_blank" rel="noopener noreferrer"><LuFacebook size={16} /> Facebook</a>}
              {instaLink && <a href={instaLink} target="_blank" rel="noopener noreferrer"><LuInstagram size={16} /> Instagram</a>}
            </div>
          )}
        </div>
      )}
      <div className="f-footer-inner">
        <span>© {new Date().getFullYear()} {name || t("footer.rights")}</span>
        <span className="f-footer-brand">
          <img src={logo} alt="" width="28" height="28" loading="lazy" />
          <span>
            {t("footer.bookingBy")} <strong style={{ color: "var(--ink-2)" }}>Bleustay</strong> · {t("footer.poweredBy")}{" "}
            <a href="https://develab.io/" target="_blank" rel="noopener noreferrer">Develab</a>
          </span>
        </span>
      </div>
    </footer>
  );
}
